
import { createFileRoute } from '@tanstack/react-router'
import ResetPassword from '@/features/auth/reset-password'

import { z } from 'zod'

const searchSchema = z.object({
  token: z.string().optional(),
})

export const Route = createFileRoute('/auth/reset-password')({
  validateSearch: (search) => searchSchema.parse(search),
  component: ResetPassword,
})
